import moment from "moment";

export const download = (file) => {
	const blob = new Blob([file]);
	var a = window.document.createElement("a");
	a.href = window.URL.createObjectURL(blob, {type: "text/csv"});

	const date = moment().format("DD-MM-YYYY");

	a.download = `Lista Documentos ${date}.csv`;

	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};


// WEBPACK FOOTER //
// ./src/businessLogic/export.js